import { Link } from '@tanstack/react-router';
import { Button, Card, EmptyState, IconSearch } from '@/design-system';

export function NotFoundPage() {
  return (
    <main className="mx-auto w-full max-w-xl px-4 py-16">
      <Card>
        <EmptyState
          icon={<IconSearch size={22} />}
          title="Página não encontrada"
          description="O endereço acessado não existe, foi movido, ou você não tem permissão para vê-lo. Registros de outras organizações são sempre tratados como inexistentes, por decisão de segurança."
          action={
            <Button asChild variant="primary">
              <Link to="/">Ir para o painel</Link>
            </Button>
          }
          secondaryAction={
            <Button asChild variant="secondary">
              <Link to="/documentos">Abrir a Lista Mestra</Link>
            </Button>
          }
        />
      </Card>
    </main>
  );
}
